import { defineComponent } from 'vue'
import moment from '~/moment'
import { Conversation } from '@/Domain/ConversationalAgent/Types/types'

export default defineComponent({
  data () {
    return {
      isSidePanelOpen: false,
      conversations: [] as Conversation[],
      searchQuery: '',
    }
  },
  computed: {
    filteredConversations () {
      const query = this.searchQuery.toLowerCase()
      return this.conversations.filter(conv =>
        conv.title && conv.title.toLowerCase().includes(query) ||
        conv.lastMessage.toLowerCase().includes(query),
      )
    },
  },
  methods: {
    formatTimestamp (timestamp: string | undefined) {
      const momentDate = moment(timestamp)
      return momentDate.isValid() ? momentDate.fromNow() : 'Just now'
    },
    toggleSidePanel () {
      this.isSidePanelOpen = !this.isSidePanelOpen
    },
  },
})
